import { createAnthropic } from '@ai-sdk/anthropic';
import type { IAgentRuntime } from '@elizaos/core';
import { getApiKey, getBaseURL, isBrowser } from '../utils/config';

/**
 * Create an Anthropic client with proper configuration
 *
 * @param runtime The runtime context
 * @returns Configured Anthropic client
 */
export function createAnthropicClient(runtime: IAgentRuntime) {
  return createAnthropic({
    apiKey: isBrowser() ? undefined : getApiKey(runtime),
    baseURL: getBaseURL(runtime),
  });
}
